module.exports = __webpack_public_path__ + "img/down.3f4c9d0a.png";